import React from 'react';
import {Text, View} from 'react-native';
import ButtonComponent from '../../../../components/ButtonComponent/ButtonComponent';
import Input from '../../../../components/Input/Input';
import {styles} from './styles';

interface IChangePasswordDrop {
  onSave: () => void;
  data?: ICommercial;
}

const BusinessData = ({onSave, data}: IChangePasswordDrop) => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Dados comerciais</Text>
      <View style={styles.containerInput}>
        <Input
          title="Gerente"
          editable={false}
          value={data?.manager}
          placeholder="Gerente..."
          mt={10}
        />
        <Input
          title="Coordenador"
          editable={false}
          value={data?.coordinator}
          placeholder="Coordenador..."
          mt={10}
        />
        <Input
          title="Vendedor"
          editable={false}
          value={data?.figureName}
          placeholder="Vendedor..."
          mt={10}
        />
        <Input
          title="Telefone do Vendedor"
          placeholder="Telefone do Vendedor..."
          editable={false}
          keyboardType="numeric"
          value={data?.cellphone}
        />
      </View>
    </View>
  );
};

export default BusinessData;
